export default __webpack_public_path__ + "static/media/a456aeb9921af39caa81a11c84fe11f3.svg";